<template>
  <div class="friend-item">
    <img :src="friend.imageURL || '/src/assets/avatar_placeholder.png'" class="avatar" />
    <div class="info">
      <div class="name">{{ friend.name }}</div>
      <div class="specifics" v-if="friend.specifics">{{ friend.specifics }}</div>
    </div>
    <div class="actions">
      <button class="icon-btn chat-btn" @click="openChat">
        <img src="../assets/friend-chat-icon.png" alt="Chat" />
      </button>
      <button class="icon-btn remove-btn" @click="removeFriend">
        <img src="../assets/chat-decline-icon.png" alt="Remove" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  friend: {
    type: Object,
    required: true
  }
});

const emits = defineEmits(['remove', 'chat']);

function removeFriend() {
  emits('remove', props.friend.id);
}

function openChat() {
  emits('chat', props.friend.id);
}
</script>

<style scoped>

.friend-item {
  display: flex;
  align-items: center;

  background: var(--card-bg, #fff);

  padding: 12px 16px;

  border-radius: 14px;

  box-shadow: 0 2px 6px rgba(0,0,0,0.04);

  margin-bottom: 12px;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;

  box-sizing: border-box;
}

.friend-item:hover {
  transform: translateY(-2px);

  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.avatar {
  width: 48px;
  height: 48px;

  border-radius: 50%;

  object-fit: cover;

  margin-right: 16px;

  flex-shrink: 0;
}

.info {
  flex: 1;

  text-align: left;

  min-width: 0;
}

.name {
  font-weight: 600;
  font-size: 16px;

  color: var(--text-primary, #111);

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.specifics {
  font-size: 14px;

  color: var(--text-secondary, #666);

  margin-top: 2px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actions {
  display: flex;
  align-items: center;

  gap: 10px;

  flex-shrink: 0;
}

.icon-btn {
  width: 36px;
  height: 36px;

  background-color: transparent;

  border: none;
  border-radius: 10px;

  cursor: pointer;

  padding: 6px;

  display: flex;
  align-items: center;
  justify-content: center;

  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
}

.icon-btn img {
  width: 32px;
  height: 32px;

  object-fit: contain;
}

.icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.chat-btn:hover {
  background-color: #2277E622;
}

.remove-btn:hover {
  background-color: #E6512233;
}

/* ========= DARK ========= */

:root[data-theme="dark"] .friend-item {
  background: #2c2c2e;
}

:root[data-theme="dark"] .friend-item:hover {
  background: #3a3a3c;
}

:root[data-theme="dark"] .name {
  color: #ffffff;
}

:root[data-theme="dark"] .specifics {
  color: #aaaaaa;
}

:root[data-theme="dark"] .icon-btn:hover {
  background-color: rgba(255, 255, 255, 0.06);
}

:root[data-theme="dark"] .chat-btn:hover {
  background-color: #3399ff22;
}

:root[data-theme="dark"] .remove-btn:hover {
  background-color: #ff444433;
}

/* ========= MOBILE ========= */

@media (max-width: 430px) {

  .friend-item {
    padding: 12px;

    border-radius: 16px;

    gap: 10px;

    margin-bottom: 10px;
  }

  .avatar {
    width: 42px;
    height: 42px;

    margin-right: 0;
  }

  .name {
    font-size: 14px;
    line-height: 1.2;
  }

  .specifics {
    font-size: 12px;
    line-height: 1.3;
  }

  .actions {
    gap: 6px;
  }

  .icon-btn {
    width: 34px;
    height: 34px;

    padding: 5px;

    border-radius: 10px;
  }

  .icon-btn img {
    width: 26px;
    height: 26px;
  }

  /* на мобиле hover не нужен */

  .friend-item:hover {
    transform: none;
    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
  }
}

</style>